import React, { Component } from "react";
import { Collapse, notification, Icon } from "antd";
import axios from "axios";
import moment from "moment";
import screenfull from "screenfull";

import { GlobalContext } from "../../../../../../../app/providers/GlobalState";

import Tarefa from "../Tarefa/Tarefa";

const Panel = Collapse.Panel;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class Modulo extends Component {
    static contextType = GlobalContext;

    state = {
        moduloid: 0,
        tituloModulo: "",
        ordemModulo: "",
        drawerModuloVisible: false,
        precedencia_nome: "",
        precedencia_concluida: false,
        //COLLAPSE
        aberto: false,
        collapsed: ["0"],
        //PERMISSOES
        curso_iniciado: false,
        //INSCRICAO
        inscrito: false,
        //FULLSCREEN
        fullscreen: false
    };

    UNSAFE_componentWillMount() {
        axios.defaults.timeout = 60 * 10 * 1000;
    }

    //CHAMADA ANTES DO RENDER
    componentDidMount() {
        //this.carregaPrecedencia();

        if (this.props.index === this.props.modulo_aberto)
            this.setState({
                aberto: true
            });
    }

    //FORMATA AS HORAS EM STRING 00H00
    formatarHoras = hora => {
        var horas = moment(hora, "HH:mm");
        if (moment.duration(hora, "minutes").asMinutes() > 59) return horas.format("HH").slice(0, 2) + "h" + horas.format("mm").slice(0, 2);
        else return horas.format("m").slice(0, 2) + "m";
    };

    alertar = bloqueado => {
        this.setState(
            {
                aberto: !this.state.aberto
            },
            () => {
                var precendencia_concluida = localStorage.getItem("estado_atividade_" + this.props.modulo.precendenciaId);

                if (this.state.aberto && !bloqueado) {
                    if (this.props.modulo.precedencia && !this.props.modulo.obrigatoria && precendencia_concluida === "false")
                        openNotificationWithIcon(
                            "info",
                            "Atenção",
                            <span>
                                Sugerimos que conclua primeiro a atividade <strong>{this.props.modulo.precedencia}</strong>
                            </span>
                        );
                    else if (this.props.modulo.precedencia && this.props.modulo.obrigatoria && precendencia_concluida === "false")
                        openNotificationWithIcon(
                            "warning",
                            "Atenção",
                            <span>
                                Tem de finalizar primeiro a atividade <strong>{this.props.modulo.precedencia}</strong>
                            </span>
                        );
                }
            }
        );
    };

    alertarAulaUnica = (moduloid, aulaid, bloqueado) => {
        this.setState(
            {
                aberto: !this.state.aberto
            },
            () => {
                var precendencia_concluida = localStorage.getItem("estado_atividade_" + this.props.modulo.precendenciaId);

                if (this.state.aberto && !bloqueado) {
                    if (this.props.modulo.precedencia && !this.props.modulo.obrigatoria && precendencia_concluida === "false") {
                        openNotificationWithIcon(
                            "info",
                            "Atenção",
                            <span>
                                Sugerimos que conclua primeiro a atividade <strong>{this.props.modulo.precedencia}</strong>
                            </span>
                        );
                        this.props.concluirAula(moduloid, aulaid);
                    } else if (this.props.modulo.precedencia && this.props.modulo.obrigatoria && precendencia_concluida === "false")
                        openNotificationWithIcon(
                            "warning",
                            "Atenção",
                            <span>
                                Tem de finalizar primeiro a atividade <strong>{this.props.modulo.precedencia}</strong>
                            </span>
                        );
                    else this.props.concluirAula(moduloid, aulaid);
                }
            }
        );
    };

    validarDisponibilidade = () => {
        var precendencia_concluida = localStorage.getItem("estado_atividade_" + this.props.modulo.precendenciaId);
        if (this.props.modulo.precedencia && this.props.modulo.obrigatoria && !precendencia_concluida && this.context.role === "UTILIZADOR")
            return true;

        return false;
    };

    calcular = aula => {
        var total = 0;

        if (aula.dt_inicio && aula.hora) {
            let d1 = moment(aula.hora, "HH:mm:ss");
            let d2 = moment(aula.dt_inicio);

            d2 = d2.set({
                hour: d1.get("hour"),
                minute: d1.get("minute"),
                second: d1.get("second")
            });

            total = d2.diff(moment(), "hours");
        } else if (aula.dt_inicio) total = moment(aula.dt_inicio).diff(moment(), "hours");
        else if (aula.hora) {
            let d1 = moment(aula.hora, "HH:mm:ss");
            let d2 = moment();

            d2 = d2.set({
                hour: d1.get("hour"),
                minute: d1.get("minute"),
                second: d1.get("second")
            });

            total = d2.diff(moment(), "hours");
        }

        return total;
    };

    notificar = (aula, tipo) => {
        if (aula.dt_inicio && aula.hora) {
            let d1 = moment(aula.hora, "HH:mm:ss");
            let d2 = moment(aula.dt_inicio);

            d2 = d2.set({
                hour: d1.get("hour"),
                minute: d1.get("minute"),
                second: d1.get("second")
            });

            openNotificationWithIcon("warning", "Atenção", tipo + " disponível a " + d2.format("DD/MM/YYYY") + " às " + d2.format("HH:mm"));
        } else if (aula.dt_inicio)
            openNotificationWithIcon("warning", "Atenção", tipo + " disponível a " + moment(aula.dt_inicio).format("DD/MM/YYYY"));
        else if (aula.hora) {
            let d1 = moment(aula.hora, "HH:mm:ss");
            let d2 = moment();

            d2 = d2.set({
                hour: d1.get("hour"),
                minute: d1.get("minute"),
                second: d1.get("second")
            });

            openNotificationWithIcon("warning", "Atenção", tipo + " disponível a " + d2.format("DD/MM/YYYY") + " às " + d2.format("HH:mm"));
        }
    };

    onClick = aulaId => {
        localStorage.setItem("modulo_aberto", this.props.index);
        localStorage.setItem("codigo_aula", aulaId);
    };

    onClinkConcluido = (moduloId, aulaId) => {
        localStorage.setItem("modulo_aberto", this.props.index);
        this.props.concluirAula(moduloId, aulaId);
    };

    onClinkValidar = (aula, disponivel, tipo, aulaId) => {
        localStorage.setItem("modulo_aberto", this.props.index);
        localStorage.setItem("codigo_aula", aulaId);

        if (!disponivel) {
            this.notificar(aula, tipo);
        }
    };

    onChangeCollapse = collapsed => {
        this.setState({
            collapsed
        });

        if (this.props.modulo.pagina_unica)
            this.alertarAulaUnica(this.props.modulo.id, this.props.modulo.modulo_Aula[0].id, this.props.modulo.estado === "BLOQUEADO");
        else this.alertar(this.props.modulo.estado === "BLOQUEADO");
    };

    onClickFullscreenElement = () => {
        screenfull.toggle(this.elementFullScreen.current);
        this.setState({ fullscreen: !this.state.fullscreen });
    };

    render() {
        const semaforo = estado => {
            if (estado === "ATIVO") return <span className="modulo-semaforo verde" title="Ativo" />;
            else if (estado === "FECHADO") {
                return <span className="modulo-semaforo amarelo" title="Fechado" />;
            } else {
                return <span className="modulo-semaforo vermelho" title="Bloqueado" />;
            }
        };

        //CALCULA O TOTAL DE AULAS NO MODULO E O TOTAL DE CONCLUIDAS PARA MARCAR O MODULO COMO CONCLUIDO
        const concluidos = () => {
            var totalAulas = this.props.modulo.modulo_Aula.filter(x => x.tipo_Recurso.id !== 13).length;
            var totalConcluidas = 0;

            this.props.modulo.modulo_Aula.forEach(aula => {
                if (aula?.modulo_Aulas_Utilizadores?.concluido) totalConcluidas += 1;
            });

            localStorage.setItem("estado_atividade_" + this.props.modulo.id, totalAulas === totalConcluidas);
            return this.props.modulo.modulo_Aula.length > 0 && totalAulas === totalConcluidas;
        };

        //MONTA O TITULO E LOGICA NO MODULO
        const tituloModulo = (
            <div>
                <div className="modulo-header">
                    <div className="modulo-container-esquerda modulo-container-esquerda-desktop">
                        {semaforo(this.props.modulo.estado)}
                        <span className="modulo-num">{this.props.modulo.nome}</span>
                        {this.props.modulo.precedencia && (
                            <span
                                className="modulo-precedencia"
                                title={`Precedência${this.props.modulo.obrigatoria ? " obrigatória" : ""}: ${
                                    this.props.modulo.precedencia
                                }`}
                            >
                                <Icon type="api" className={this.props.modulo.obrigatoria ? "obrigatoria" : ""} />
                            </span>
                        )}
                        <span className="modulo-validacao">
                            <i
                                className={
                                    concluidos() && this.props.modulo.estado !== "BLOQUEADO" ? "fa fa-check" : "fa fa-check por-validar"
                                }
                            />
                        </span>
                    </div>
                    <div className="modulo-container-esquerda modulo-container-esquerda-mobile">
                        <div className="container-lvl1">
                            {semaforo(this.props.modulo.estado)}
                            <span className="modulo-num">{this.props.modulo.nome}</span>
                            <span className="modulo-validacao">
                                <i
                                    className={
                                        concluidos() && this.props.modulo.estado !== "BLOQUEADO" ? "fa fa-check" : "fa fa-check por-validar"
                                    }
                                />
                            </span>
                        </div>
                        <div className="container-lvl2">
                            {this.props.modulo.precedencia && (
                                <span
                                    className="modulo-precedencia"
                                    title={`Precedência${this.props.modulo.obrigatoria ? " obrigatória" : ""}: ${
                                        this.props.modulo.precedencia
                                    }`}
                                >
                                    <Icon type="api" className={this.props.modulo.obrigatoria ? "obrigatoria" : ""} />
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="modulo-container-direita">
                        <span className="modulo-datas">
                            {moment().isAfter(moment(this.props.modulo.dt_termino)) &&
                            this.props.modulo.estado === "ATIVO" &&
                            !concluidos() ? (
                                <Icon type="warning" className="atrasado" />
                            ) : (
                                ""
                            )}{" "}
                            {this.props.modulo.dt_inicio ? (
                                <>
                                    Inicio: <strong>{moment(this.props.modulo.dt_inicio).format("DD/MM/YYYY")}</strong>
                                </>
                            ) : (
                                ""
                            )}{" "}
                            {this.props.modulo.dt_termino ? (
                                <>
                                    Término: <strong>{moment(this.props.modulo.dt_termino).format("DD/MM/YYYY")}</strong>
                                </>
                            ) : (
                                ""
                            )}
                        </span>
                        <span className="modulo-validacao">
                            <i
                                className={
                                    concluidos() && this.props.modulo.estado !== "BLOQUEADO" ? "fa fa-check" : "fa fa-check por-validar"
                                }
                            />
                        </span>
                    </div>
                </div>
                {this.props.modulo.objetivos && (
                    <div className="modulo-header-objetivos">
                        <span>{this.props.modulo.objetivos}</span>
                    </div>
                )}
            </div>
        );

        //MONTA A RESPETIVA AULA
        const montaAula = (aula, estado) => {
            var inicioUrl = `/curso/${this.props.nomeDisciplina?.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/${aula.nome
                .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                .toLowerCase()}-${Math.floor(100000 + Math.random() * 900000)}`;

            return (
                <Tarefa
                    aula={aula}
                    inicioUrl={inicioUrl}
                    moduloIndex={this.props.index}
                    onClick={this.onClick}
                    validarDisponibilidade={this.validarDisponibilidade}
                    inscrito={this.props.inscrito}
                    estado={estado}
                    modulo={this.props.modulo}
                />
            );
        };

        return (
            <>
                <Collapse
                    defaultActiveKey={this.props.disabled ? [] : [localStorage.getItem("modulo_aberto")]}
                    bordered={false}
                    onChange={this.onChangeCollapse}
                    key={this.props.index}
                >
                    <Panel
                        header={tituloModulo}
                        key={this.props.index}
                        className={!this.props.modulo.ativo ? "modulo ativo" : "modulo"}
                        disabled={this.props.disabled}
                    >
                        <ul>
                            {this.props.modulo.modulo_Aula.map((aula, index) => (
                                <li key={index}>
                                    <div className={aula.ativo ? "nivel1" : "nivel1 inativo"}>
                                        {montaAula(aula, this.props.modulo.estado === "ATIVO")}
                                        {aula.tipo_Recurso.id !== 13 && (
                                            <span className="validacao">
                                                <i
                                                    className={
                                                        aula.modulo_Aulas_Utilizadores && aula.modulo_Aulas_Utilizadores.concluido
                                                            ? "fa fa-check"
                                                            : "fa fa-check por-validar"
                                                    }
                                                />
                                            </span>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </Panel>
                </Collapse>
            </>
        );
    }
}

export default Modulo;
